import React from 'react';
import ReactPaginate from 'react-paginate';
import './styles.css';

interface PropsType {
  meta : any,
  handlePageChange : any,
}

export const Pagination: React.FC<PropsType> = ({ meta, handlePageChange }) => {
  if (meta.pages && meta.pages > 0) {
    return (
      <div className="px-2 py-3 d-flex align-items-center justify-content-between">
        <div className="d-flex justify-content-end w-100">
          <div className="pagination-wrapper">
            <ReactPaginate
              previousLabel="Prev"
              nextLabel="Next"
              breakLabel="..."
              forcePage={meta.current ?? 0}
              pageCount={meta.pages ?? 0}
              marginPagesDisplayed={2}
              pageRangeDisplayed={2}
              onPageChange={(data:any) => {
                handlePageChange(data.selected);
              }}
              breakClassName={`position-relative d-inline-flex bg-light border-secondary text-secondary
            align-items-center px-4 py-2 border text-sm font-medium`}
              previousClassName="prev-class"
              nextClassName="next-class"
              pageClassName="page"
              activeClassName="active-page"
              disabledClassName="disabled-class"
              disabledLinkClassName="disabled-class"
            />
          </div>
        </div>
      </div>
    );
  }
  return (<div />);
};
